import "./MSSeparatorContainer.css";
import { ActualLangContext } from "../../../contexts/ActualLangContext";
import { useContext } from "react";
import MicrosoftLogo from "../../../assets/MSPartner.svg";
import { getResourceUrl } from "../../../config/urls";
import { msSeparator as msSeparatorTextEn } from "../../../config/home/textPage";
import { homeEs } from "../../../config/home/home";
import { Container } from "react-bootstrap";
import { MSSeparator } from "./Components/MSSeparator/MSSeparator";
import PropTypes from "prop-types";

const MSSeparatorItemsEN = [
  {
    text: "Business Applications",
    numOfSpecializations: null,
    specializations: [],
  },
  { text: "Data & AI", numOfSpecializations: "1 Specialization", specializations: ["Analytics"] },
  {
    text: "Digital & App Innovation",
    numOfSpecializations: "1 Specialization",
    specializations: ["Agentic DevOps with Microsoft Azure and GitHub"],
  },
  { 
    text: "Infrastructure Azure", 
    numOfSpecializations: "1 Specialization", 
    specializations: ["Azure Virtual Desktop"] 
  },
  {
    text: "Modern Work",
    numOfSpecializations: "5 Specializations",
    specializations: [
      "Copilot",
      "Adoption and Change Management",
      "Teamwork Deployment",
      "Custom Solutions for Microsoft Teams",
      "Meetings and Meeting Rooms for Microsoft Teams",
    ],
  },
  {
    text: "Security",
    numOfSpecializations: "2 Specializations",
    specializations: ["Identity and Access Management", "Threat Protection"],
  },
];
const MSSeparatorItemsES = [
 ...MSSeparatorItemsEN,
];

export const MSSeparatorContainer = ({ items }) => {
  const { actualLang } = useContext(ActualLangContext);
  const isEnglish = actualLang === "en";
  if (!items) {
    items = isEnglish ? MSSeparatorItemsEN : MSSeparatorItemsES;
  }

  const handlePildoraClick = () => {
    const url = getResourceUrl(
      "BLOG",
      "ARTICLES",
      "MICROSOFT_DESIGNATIONS",
      actualLang
    );
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Container className="py-5" fluid>
      <Container className="py-4" fluid>
      <div className="titleContainer">
        <MSSeparator.Title style={{ whiteSpace: "pre-line" }}>
          {isEnglish ? msSeparatorTextEn.title : homeEs.msSeparator.title}
        </MSSeparator.Title>
      </div>
      <div className="logoContainer">
        <MSSeparator.Image
          src={MicrosoftLogo}
          alt="Microsoft Solutions Partner"
          width={290}
          height={143}
        />
      </div>

      <MSSeparator className="homeMSSeparatorContainer">
        <MSSeparator.ItemsList
          items={items}
          onPildoraClick={handlePildoraClick}
        />
      </MSSeparator>
    </Container>
    </Container>
  );
};

MSSeparatorContainer.propTypes = {
  items: PropTypes.array,
};